import cookies from "browser-cookies"

// TODO Ensure the log rocket parameters are read from the environment, like the cookie-domain?!
const COOKIE_DOMAIN = process.env.GATSBY_COOKIE_DOMAIN
const DEFAULT_SAMPLE_RATE = 5 // enable 5% of the sessions to be recorded
const LOG_ROCKET_COOKIE_NAME = "lre7p7ly1en2"
const LOG_ROCKET_LIBRARY_MIN_JS_SRC = "https://cdn.lr-in.com/LogRocket.min.js"
const LOG_ROCKET_PAGE_OVERRIDES = {
  // enable 10% of the sessions to be recorded for quote offers test pages, so sample rate will be 10
  "/save/quote-offers-c/": 10,
  "/save/quote-offers-d/": 10,
  "/save/quote-offers-e/": 10,
  "/save/quote-offers-f/": 10,
  "/save/quote-offers-g/": 10,
  "/save/quote-offers-h/": 10,
  "/save/quote-offers-i/": 10,
  "/save/quote-offers-j/": 10,
  "/save/quote-offers-k/": 10,
  "/save/quote-offers-l/": 10,
}

const setLogRocketCookie = (value) => {
  cookies.set(LOG_ROCKET_COOKIE_NAME, `LRS_${Math.floor(value)}`, {
    domain: COOKIE_DOMAIN,
    path: "/",
    expires: 1, // a day
  })
}

export const shouldLogRocketRecord = () => {
  // Get the sample rate from the cookie or generate a new random value
  const logRocketCookieValue = cookies.get(LOG_ROCKET_COOKIE_NAME)
  const randomSampleRate = Math.random() * 100 + 1
  const logRocketSampleRate = logRocketCookieValue
    ? parseInt(logRocketCookieValue.split("_")[1])
    : randomSampleRate
  // Check if current page has a sample rate override, if not use the default sample rate
  const { pathname } = window.location || {}
  const sampleRate = LOG_ROCKET_PAGE_OVERRIDES.hasOwnProperty(pathname)
    ? LOG_ROCKET_PAGE_OVERRIDES[pathname]
    : DEFAULT_SAMPLE_RATE
  // If the log rocket sample rate is within the desired range, record the session
  if (logRocketSampleRate > 100 - sampleRate) {
    setLogRocketCookie(100)
    return true
  }
  // If not within range, just update the cookie with the new sample rate
  setLogRocketCookie(logRocketSampleRate)
  return false
}

let log_rocket_is_running = false

const isLogRocketLibraryLoaded = () => typeof window.LogRocket != "undefined"

const initializeLogRocket = () => {
  setTimeout(() => {
    if (isLogRocketLibraryLoaded() && !log_rocket_is_running) {
      window.LogRocket.init("pyembx/insurify", {
        dom: {
          inputSanitizer: true,
        },
      })
      log_rocket_is_running = true
    }
  }, 10)
}

const getLogRocketLibraryScriptTag = () => {
  const lrScript = document.createElement("script")
  lrScript.crossOrigin = "anonymous"
  lrScript.src = LOG_ROCKET_LIBRARY_MIN_JS_SRC
  lrScript.async = true
  lrScript.onload = initializeLogRocket
  return lrScript
}

const speedCurveTestsRunning = () =>
  window.navigator.userAgent.indexOf("PTST/SpeedCurve") !== -1

export const isLogRocketEnabled = () =>
  shouldLogRocketRecord() && !speedCurveTestsRunning()

export const LogRocketLibraryMinJs = getLogRocketLibraryScriptTag()
